'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.fleetInsight',
dependencies:['ui.router'],
configs:[require('./fleetInsightConfig')],
components:[
require('./fleetInsightController'),
require('./components/fleetIncidentsDirective'),
require('./components/fatigueTrendsDirective'),
require('./components/fatigueTrends/fleetListDirective'),
require('./components/fatigueTrends/fleetHistogramDirective'),
require('./components/fatigueTrends/histogramPlotterDirective'),
require('./components/fleetIncidents/bucketedIncidentGraphDirective'),
require('./components/fleetIncidents/incidentBucketTypePickerDirective'),
require('./components/fleetIncidents/incidentTypePickerDirective')]});
//# sourceMappingURL=index.js.map
